module.exports = __webpack_public_path__ + "img/32ne.5b8c894f.svg";